import { atom } from "recoil";
const breadCrumbAtom = atom({
    key: "breadCrumbAtom",
    default: {
        locationName: ''
    },
});

export { breadCrumbAtom };
